import { render, staticRenderFns } from "./RevisionEntryConfiguration.vue?vue&type=template&id=46b4c8c6&scoped=true"
import script from "./RevisionEntryConfiguration.vue?vue&type=script&lang=js"
export * from "./RevisionEntryConfiguration.vue?vue&type=script&lang=js"
import style0 from "./RevisionEntryConfiguration.vue?vue&type=style&index=0&id=46b4c8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b4c8c6",
  null
  
)

export default component.exports